import { render, staticRenderFns } from "./ListQuizzes.vue?vue&type=template&id=96718786&scoped=true&"
import script from "./ListQuizzes.vue?vue&type=script&lang=js&"
export * from "./ListQuizzes.vue?vue&type=script&lang=js&"
import style0 from "./ListQuizzes.vue?vue&type=style&index=0&id=96718786&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96718786",
  null
  
)

export default component.exports